import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    timezone: {
      timezone_name: "",
      timezone_offset: 0,
      state: "",
    },
    status: "ready", // ready, loading, error, success,
    userId: null,
    userName: null,
    searchData: {},
    forceRerender: true,
  },
  mutations: {
    authRequest(state) {
      state.status = "loading";
    },
    authSuccess(state, payload) {
      console.log("payload", payload);

      state.status = "success";
      state.userId = payload.userId;
      state.userName = payload.userName;
      state.searchData = {};
    },
    authError(state) {
      state.status = "error";
    },
    logout(state) {
      state.status = "ready";
      state.searchData = {};
      state.timezone = {
        timezone_name: "",
        timezone_offset: 0,
        state: "",
      };
    },
    setSearchData(state, payload) {
      if (Object.keys(payload).length === 0) state.searchData = {};
      state.searchData = { ...state.searchData, ...payload };
    },
    setTimezone(state, payload) {
      console.log("payload", payload);
      state.timezone = { ...state.timezone, ...payload };
    },
    forceRerender(state) {
      state.forceRerender = !state.forceRerender;
    },
  },
  actions: {
    login({ commit }, { userId, userName }) {
      commit("authRequest");
      commit("authSuccess", { userId, userName });
    },
    logout({ commit }) {
      localStorage.removeItem("vuex");
      localStorage.removeItem("token");
      sessionStorage.removeItem("token");
      sessionStorage.removeItem("vuex");
      commit("logout");
    },
    check_login({ commit }) {
      commit("authSuccess");
    },
  },
  plugins: [
    createPersistedState({
      storage: window.sessionStorage,
    }),
  ],
});
